import { useTranslation } from '../../../lib/i18n';
import type { CancelTaskFlow } from '../../../lib/use-cancel-task';
import { Modal } from '../../Modal';
import { Button, Typography } from '../ui';
import styles from './CancelTaskConfirm.module.css';

// The confirm in front of "Cancel this task". Cancelling halts the agent's loop and writes a terminal
// status, and there is no un-cancel anywhere in the product — so it takes the same shape every other
// destructive action here does: a named confirm (never a bare "Cancel"/"OK" pair, which in THIS dialog
// would be unreadable), the destructive skin on the action that ends something, and the dismissal
// spelled out as keeping the task.
//
// Rendered by whichever surface owns the flow; it draws nothing until a target is requested.
export function CancelTaskConfirm({ flow }: { flow: CancelTaskFlow }) {
  const { t } = useTranslation();
  if (!flow.target) return null;

  return (
    <Modal
      open
      onClose={flow.dismiss}
      width={440}
      maxHeightPx={650}
      scrollBody
      title={t('tasks.cancel.title')}
      labelledBy="cancel-task-title"
      footer={
        <>
          <Button variant="outlined" onClick={flow.dismiss} disabled={flow.busy}>
            {t('tasks.cancel.keep')}
          </Button>
          <Button color="destructive" loading={flow.busy} onClick={() => void flow.confirm()}>
            {t('tasks.cancel.confirm')}
          </Button>
        </>
      }
    >
      <Typography variant="p2" color="secondary" component="p">
        {t('tasks.cancel.body', { title: flow.target.title })}
      </Typography>
      {flow.error && (
        <Typography variant="p2" component="p" className={styles.error}>
          {flow.error}
        </Typography>
      )}
    </Modal>
  );
}
